module.exports = __webpack_public_path__ + "static/img/banner2.2384b97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/campaign/banner2.jpg
// module id = szLE
// module chunks = 0